export default {
  selectedIds: [],
  selectedForChartIds: [],
  allKeywordsForChart: [],
  dateRangeTypesSelect: [
    { text: 'Weekly', value: 10 },
    { text: 'Monthly', value: 20 },
    { text: 'Quarterly', value: 30 }
  ],
  termDescription: {
    0: 'Short',
    1: 'Long',
    2: 'Very long'
  },
  termDescriptionColors: {
    0: 'green',
    1: 'red',
    2: 'black'
  },
  fishingMethods: {
    project: 'GET_FISHING_KEYWORDS',
    competitor: 'GET_COMPETITOR_FISHING_KEYWORDS',
    url: 'GET_URL_FISHING_KEYWORDS'
  },
  fishingTypesSelect: [
    { text: 'Ranking', value: 0, shortText: 'R', methods: ['GET_FISHING_KEYWORDS', 'GET_URL_FISHING_KEYWORDS'] },
    { text: 'Competitors Ranking', value: 100, shortText: 'CR', methods: ['GET_COMPETITOR_FISHING_KEYWORDS'] },
    { text: 'Shared', value: 200, shortText: 'SH', methods: ['GET_COMPETITOR_FISHING_KEYWORDS'] },
    { text: 'RankingOtherPage', value: 300, shortText: 'ROP', methods: ['GET_URL_FISHING_KEYWORDS'] },
    { text: 'Related', value: 400, shortText: 'REL', methods: ['GET_FISHING_KEYWORDS', 'GET_COMPETITOR_FISHING_KEYWORDS', 'GET_URL_FISHING_KEYWORDS'] }
  ]
}



// WEBPACK FOOTER //
// ./src/store/keyword/state.js